interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  desc?: string;
  align?: "center" | "left";
}

export default function SectionHeading({ eyebrow, title, desc, align = "center" }: SectionHeadingProps) {
  const isCenter = align === "center";
  return (
    <div className={`${isCenter ? "text-center mx-auto max-w-2xl" : "text-left max-w-2xl"}`}>
      <span className="inline-flex items-center gap-2 text-xs md:text-sm font-medium text-accent-700 bg-accent-100 px-3 py-1 rounded-full">
        <i className="ri-bookmark-3-line"></i>
        {eyebrow}
      </span>
      <h2 className="mt-4 font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-snug">
        {title}
      </h2>
      {desc && (
        <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">{desc}</p>
      )}
    </div>
  );
}